export default __webpack_public_path__ + "static/media/8E5373EF-7491-49D5-BB71-CDD8DB2D20E4_1_105_c.e7136611.jpeg";